import React from 'react';
import { useCurrency } from '../context/CurrencyContext';
import './CurrencyToggle.css';

const CurrencyToggle = () => {
  const { currency, toggleCurrency } = useCurrency();

  return (
    <button className="currency-toggle-btn" onClick={toggleCurrency}>
      {currency}
    </button>
  );
};

export default CurrencyToggle;